import { useParams, useSearchParams } from 'react-router-dom';
import { useNavigationPresentation } from '@/lib/tradeNavigation';
import Clients from './Clients';
import { CustomerRegister, CustomerDetail } from './TradesCustomers';
export default function OperatingClients() {
  const presentation = useNavigationPresentation();
  const { cid, pid } = useParams();
  const [params] = useSearchParams();
  if (presentation.pending) return <div className="p-6" role="status">Loading your workspace… <button onClick={presentation.refresh}>Retry</button></div>;
  if (!presentation.trades) return <Clients />;
  const user = presentation.user;
  if (!['admin', 'office', 'super_admin', 'quantity_surveyor'].includes(user?.role)) return <p className="p-6">Customer records require office access.</p>;
  const id = cid || params.get('id');
  const key = JSON.stringify([user.org_id, user.id, user.role, id, pid]);
  return id ? <CustomerDetail key={key} cid={id} pid={pid} user={user} /> : <CustomerRegister key={key} />;
}
